
import { Tabs } from 'ant-design-vue';
import {
  defineComponent, PropType, ref,
} from 'vue';

export default defineComponent({
  components: {
    aTabs: Tabs,
    aTabPane: Tabs.TabPane,
  },
  props: {
    tabs: {
      type: Array as PropType<string[]>,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
  },
  emits: ['update:active'],
  setup(props, { emit }) {
    const activeTab = ref('');
    const handleClick = (s: string) => {
      activeTab.value = s;
      emit('update:active', s);
    };
    if (props.tabs.length > 0) handleClick(props.tabs[0]);

    return {
      activeTab,
      handleClick,
    };
  },
});
